<template>
  <div>
    <a
      :class="options.class"
      @click="$parent.$parent.$parent.otpFunction(data)"
      data-toggle="modal"
      data-target="#otpModal"
      href="#"
      v-role="roles"
    >
    <i class="ag-icon ag-icon_key" style="font-size: 1.2em; opacity: 0.8" data-toggle="tooltip" title="Generate Admin Mode Password"></i>
    </a>
  </div>
</template>

<script>
import { Roles } from "@/helpers/enums/Roles";

export default {
  name: "tableOtpComponent",
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  computed: {
    roles() {
      return this.options.roles
        ? this.options.roles
        : [
            Roles.AGMSAdmin,
            Roles.PartnerAdmin,
            Roles.GroupAdmin,
            Roles.GroupAudit,
            Roles.CompanyAdmin,
            Roles.SiteAdmin,
            Roles.SiteAudit,
          ];
    },
  },
};
</script>

<style scoped></style>
